import React, { useContext, useEffect, useState } from "react";
import L from "leaflet";
import { CircleMarker, MapConsumer, MapContainer, Marker, ScaleControl, TileLayer, Tooltip } from "@monsonjeremy/react-leaflet";

import leyendaEpicentro from "../../img/leyenda_epicentro.png"
import { traerRespuestas } from "./Resultados";
import Contexto from "../comun/Contexto";

export default function MapaIntensidades(props) {
    /* Contexto */
    const { urlBaseRest, mapaIntensidadesURLCapaBase, mapaIntensidadesCentro, mapaIntensidadesZoomInicial } = useContext(Contexto);
    
    /* Estado */    
    const [respuestas, setRespuestas] = useState([]);
    
    /* Parametros */
    //const centro = [5.6, -72.9]; 
    //const zoomInicial = 5;

    /* Efectos */
    useEffect(()=> {       
        console.log("trayendo respuestas para "+props.idSismo) 
        traerRespuestas(urlBaseRest, props.idSismo, setRespuestas);
    }, []);    

    const simboloEstrella = `data:image/svg+xml;utf8,${encodeURIComponent(`<?xml version="1.0" encoding="iso-8859-1"?>
    <svg height="200px" width="200px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 53.867 53.867" xml:space="preserve" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <polygon style="fill:#000;" points="26.934,1.318 35.256,18.182 53.867,20.887 40.4,34.013 43.579,52.549 26.934,43.798 10.288,52.549 13.467,34.013 0,20.887 18.611,18.182 "></polygon> </g>
    </svg>
    `)}`;

    const IconoEstrella = L.icon({
        iconUrl: simboloEstrella,
        iconSize: [20, 20],
        iconAnchor: [12, 12],
        popupAnchor: [0, 0],
    });


    const colorSimbologia = (inte)=>{
        if (inte <= 2) {
            return "#d9d9f2"
        } else if (inte <= 3) {
            return "#9ed3ff"
        } else if (inte <= 4) {
            return "#00ffff"
        } else if (inte <= 5) {
            return "#00ff00"
        } else if (inte <= 6) {
            return "#ffff00"
        } else if (inte <= 7) {
            return "#ffaa00"
        } else {
            return "#ff0000"
        } 
    }

    const centro = props.centro?props.centro:mapaIntensidadesCentro;
    const zoom = props.zoom?props.zoom:mapaIntensidadesZoomInicial;
    const maxZIndex = 9999;

    /* Render */   
    return(      
        <MapContainer attributionControl={false} center={centro} zoom={zoom} 
        zoomSnap= {props.mapaIntensidadesZoomSnap}
        scrollWheelZoom={true} 
        style={{height:"100%", width:"100%", position:"relative"}}>
            <ScaleControl position="bottomleft" imperial={false}/>
            {props.mostrarCoordenadas &&
            <div id="divCoordenadas" style={{
                zIndex: maxZIndex,
                backgroundColor: "#eeeedd",
                position: "absolute",
                left: "5px",
                bottom: "5px"
            }}>coordenadas</div>           
            }
            <div style={{
                zIndex: maxZIndex,
                position: "absolute",
                right: "5px",
                bottom: "2px"
            }}><img src={leyendaEpicentro} alt={"epicentro"} height="30" /></div>      
            <MapConsumer>
            {
				(map) => {	
				    map.on("mousemove", (e) => {                        
                        let latlng = e.latlng;
                        let q = document.getElementById("divCoordenadas");
                        if (q) {
                            q.innerHTML = "lat: " + latlng.lat.toFixed(3) + ", lon: " + latlng.lng.toFixed(3);                        
                        }                    
				    });

                    return null;
                }            
            }
            </MapConsumer>
            
            <TileLayer url={mapaIntensidadesURLCapaBase} />
            
            {props.resumenSismo &&
            <Marker position={[props.resumenSismo.latitud, props.resumenSismo.longitud]} icon={IconoEstrella}/>
            } 
             
            {respuestas.map((r, index)=>{
                let lat = parseFloat(r.LATITUD);
                let lon = parseFloat(r.LONGITUD);
                let color = null;
                if (r.INT_RED <= 2) {
                    color= "#d9d9f2"
                } else if (r.INT_RED <= 3) {
                    color= "#9ed3ff"
                } else if (r.INT_RED <= 4) {
                    color= "#00ffff"
                } else if (r.INT_RED <= 5) {
                    color= "#00ff00"
                } else if (r.INT_RED <= 6) {
                    color= "#ffff00"
                } else if (r.INT_RED <= 7) {
                    color= "#ffaa00"
                } else {
                    color= "#ff0000"
                }
                return(                    
                    <CircleMarker
                    key={r.ID_CENTRO_POBLADO}
                    center={[lat, lon]} 
                    radius={10}
                    pathOptions={{ color: '#999999', weight: 1, fillColor: color, fillOpacity:1 }} > 
                    <Tooltip opacity={1}>
                        <table>
                            <tbody>
                            <tr><td style={{fontWeight:"bold"}}>Sitio:</td><td>{r.NOMBRE_CENTRO_POBLADO}</td></tr>
                            <tr><td style={{fontWeight:"bold"}}>Intensidad:</td>
                            <td style={{ display:"flex",
                            flexDirection:"row", justifyContent:"center"}}>
                                <span style={{
                                height: "25px",
                                width: "25px",
                                backgroundColor: colorSimbologia(r.INT_RED),
                                borderRadius: "50%",
                                display: "flex",
                                alignItems:"center",
                                justifyContent:"center",
                                textAlign:"center",
                                fontWeight:"bold"
                                }}
                                >{r.INT_RED}</span></td></tr>
                            </tbody>
                        </table>
                    </Tooltip>
                    </CircleMarker>
                )
            })}
        </MapContainer>
    )
}